import { createBridgeChannel } from './createBridgeChannel';
import { ADD_SPACE_SIDER_CHANNEL, } from '../types/composerUiChannel';
/**
 * Cross-app channel for the composer's "add another space" sider state,
 * built on the generic {@link createBridgeChannel} primitive. See
 * `types/composerUiChannel.ts` for the payload contract and the
 * backwards-compatibility policy.
 *
 * One-directional (the composer emits, grid surfaces subscribe), so the
 * surface is deliberately minimal: one emit hook, one subscribe hook — no
 * origin/echo machinery, and no bridge-taking variants until something
 * outside React actually needs them (the underlying `channel` object has
 * them if that day comes).
 */
var channel = createBridgeChannel(ADD_SPACE_SIDER_CHANNEL);
/**
 * Subscribe to sider state changes from inside a React component. The
 * subscription is set up once per bridge instance; the latest `listener`
 * closure runs on every message, so callers don't need to memoize it.
 */
export function useAddSpaceSiderState(listener) {
    channel.useSubscribe(listener);
}
/**
 * Returns a stable callback that emits the sider's current state on the
 * shell bridge.
 */
export function useEmitAddSpaceSiderState() {
    return channel.useEmit();
}
